import MoodBoard from "./MoodBoard.jsx";
import Analytics from "./Analytics.jsx";
import './MyInfo.css';
import './PreviousDay.css';

function MyInfo() {
  return (
    <div>
      <div className="info-container">
        Here are your analytics:
      </div>
      
    </div>
  );
}

export default MyInfo;